const key = "deny-show-markdown";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	const newDeny = { Effect: "Deny", Path: "/feedback/agency/markdown/read" };
	role.Actions.push(newDeny);
};

export const  denyShowMarkdown = [key, applicable, modify];